<template>
  <div class="deposit">
    <my-header title="Deposit"></my-header>
    <div class="box" v-show="walletAddr">
      <div class="ewm">
        <canvas ref="qrcodeCanvas"></canvas>
      </div>
      <div class="address">
        {{ walletAddr }}
      </div>
      <div class="ui instagram button" @click="copyAddress">
        COPY THE ABOVE ADDRESS
      </div>
    </div>
    <div class="matters">
      <div class="title">Matters needing attention</div>
      <div class="item">
        1.Do not recnarge any non-BTC assets to the above add essotherwi se the
        assets will not be recovered
      </div>
      <div class="item">
        2.After recharging. it needs the confirmation of the whgle network n ode
        and arrives at the accouht afterone networkconfirmation
      </div>
      <div class="item">
        3.Minimum recharge amount 0.001 BTC less than the minimum amo unt of
        recharge will not be charged.
      </div>
      <div class="item">
        4. The replenishment address will not changeand thereplenishment can be
        repeated.
      </div>
    </div>
  </div>
</template>

<script>
import { getDeposit } from "../http/api";
import MyHeader from "@/components/MyHeader.vue";
import QRCode from "qrcode";
export default {
  name: "depositView",
  components: {
    MyHeader,
  },
  data() {
    return {
      walletAddr: "",
    };
  },
  async created() {
    const res = await getDeposit();
    if (res && res.data) {
      this.walletAddr = res.data.walletAddr;
      this.generateQRCode();
    }
  },
  methods: {
    copyAddress() {
      this.copyToClipboard(this.walletAddr);
    },
    generateQRCode() {
      const canvas = this.$refs.qrcodeCanvas;
      const text = this.walletAddr;
      QRCode.toCanvas(canvas, text, function (error) {
        if (error) {
          console.error(error);
        }
      });
    },
    copyToClipboard(text) {
      // 创建一个临时 textarea 元素
      var textarea = document.createElement("textarea");
      textarea.value = text;
      // 将 textarea 添加到 DOM 中
      document.body.appendChild(textarea);
      // 选中并复制文本
      textarea.select();
      document.execCommand("copy");
      // 移除临时元素
      document.body.removeChild(textarea);
      this.$toast.show("Replicating Success", "40%");
    },
  },
};
</script>

<style lang="less" scoped>
.deposit {
  background-color: #fff;
  padding-bottom: 40px;
  .box {
    width: 80%;
    margin: 0 auto;
    padding-bottom: 20px;
    padding-top: 20px;
    text-align: center;
    border-radius: 4px;
    .ewm {
      width: 52%;
      margin: 10px auto;
      img {
        width: 100%;
        display: block;
      }
    }
    .address {
      text-align: center;
      margin: 0 auto;
    }
    .button {
      margin-top: 10px;
      font-size: 13px;
    }
  }
  .matters {
    width: 90%;
    margin: 20px auto;
    font-size: 16px;
    .title {
      font-weight: bold;
      margin-bottom: 20px;
    }
    .item {
      margin-bottom: 14px;
    }
  }
}
</style>